import { CpuCount } from "@pdfking/compatibility"
import { WorkerPool } from "@pdfking/functionpool"
import type { Executor, TaskDescriptor, TaskMap } from "@pdfking/planner"

import type { ExecutionContext, WorkerEngineOptions } from "#public"
import type { WireRequest, WireResponse } from "#public"

import { EngineMaker } from "../../internal/MessageForward"

export const CreateWorkerEngine = <TM extends TaskMap>(
  descriptor: TaskDescriptor,
  config: WorkerEngineOptions
): Executor<TM, ExecutionContext> =>
  EngineMaker(
    forward =>
      WorkerPool<WireRequest, WireResponse>(config.worker, config.workers ?? CpuCount(), forward),
    descriptor,
    config
  )
